module.exports = __webpack_public_path__ + "static/media/banner-mobile.84ffd73b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about-us/images/banner-mobile.jpg
// module id = 1103
// module chunks = 2